<span class="toggle" (click)="onClick()">
  <input class="toggle-input" type="checkbox" />
  <button class="toggle-btn "
          [ngClass]="{'toggle-btn-on': eveModel,
          'toggle-btn-off': !eveModel}"
          [attr.aria-expanded]="eveModel">
  </button>
</span>
<eve-validation-errors></eve-validation-errors>
